module.exports = __webpack_public_path__ + "static/media/el.68fcef73.jpg";